export default function components(options) {
return (
    {
        MuiSkeleton:{
            defaultProps:{
                animation:"wave"
            }
        }
    }
)

}